import * as selectors from './templates.selectors';
import reducer from './templates.reducers';

export default reducer;
export { selectors, reducer };
export { TemplateAction } from './templates.actions';
export { TemplateEffects } from './templates.effects';
export { Template, TemplateRelationships, TemplateState } from './templates.models';
export { TemplateService } from './templates.service';
